// extracted by css-extract-rspack-plugin
export default {"errorHead":"FormErrors__errorHead--qxHFR"};